import { useRef, useState } from "react";
import Modal from "../Modal";
import { useDeleteDealTableMutation } from "../../store/apiSlices/dealTracker";
import { TrashIcon } from "../Icons";

export default function DeleteTableModal({
  id,
  title,
}: {
  id: number | string;
  title: string;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [deleteTable] = useDeleteDealTableMutation();

  const [confirmText, setConfirmText] = useState("");

  const REQUIRED_TEXT = "DELETE";
  const isConfirmed = confirmText === REQUIRED_TEXT;

  const toggleModal = () => {
    if (dialogRef.current?.open) {
      dialogRef.current?.close();
    } else {
      dialogRef.current?.showModal();
    }
  };

  const handleDelete = async () => {
    if (confirmText !== "DELETE") return;

    await deleteTable(id);
    toggleModal();
  };

  return (
    <div className="flex items-center justify-center">
      <button
        onClick={toggleModal}
        className="p-1 rounded-lg hover:text-red-600 hover:scale-90 hover:bg-gray-100"
        title="Delete table"
      >
        <TrashIcon className="size-6" />
      </button>

      <Modal
        ref={dialogRef}
        toggleDialog={toggleModal}
        className="w-[400px] p-6 rounded-xl shadow-xl backdrop:bg-black/50"
      >
        <div className="space-y-4">
          <h1 className="font-medium text-xl text-gray-950">
            ⚠️ You are about to delete{" "}
            <span className="font-semibold">"{title}"</span>.
          </h1>

          <p className="text-sm text-gray-900">
            Please confirm that you want to permanently remove this item.
          </p>

          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder={`Type "${REQUIRED_TEXT}" to confirm`}
            className="input-new"
          />

          <div className="flex gap-4">
            <button
              className={`w-full p-2 rounded-xl text-white 
              ${
                isConfirmed
                  ? "bg-red-500 cursor-pointer"
                  : "bg-red-300 cursor-not-allowed"
              }`}
              disabled={!isConfirmed}
              onClick={handleDelete}
            >
              Yes, Delete
            </button>

            <button
              className="w-full text-gray-900 p-2 cursor-pointer border border-gray-900 rounded-xl"
              onClick={toggleModal}
            >
              No
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
